import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})

export class ClubNotifStrategy implements INotifTextStrategy {
  public createText(activity: ActivitiesAggrigatorModel, receiver: string, isFireBaseContext: boolean): string {
    return isFireBaseContext
      ? this.getFirebaseText(activity)
      : this.getTemplateText(activity);
  }


  // ---------- Firebase context ----------
  private getFirebaseText(activity: ActivitiesAggrigatorModel): string {
    const data = activity?.inDirectObject?.data;
    const actorName = activity?.actor?.fullName ?? '';

    switch (activity?.verb) {
      case ActivityVerbEnum.ClubJoinRequested:
        return `${actorName} درخواست عضویت در باشگاه کتابخوانی ${data?.name} را دارد.`;

      case ActivityVerbEnum.Coursed:
        return `باشگاه کتابخوانی ${actorName} یک دورۀ مطالعاتی جدید را آغاز کرد.`;

      case ActivityVerbEnum.CourseEnded:
        return `باشگاه کتابخوانی ${actorName} دورۀ مطالعاتی خود را به پایان رساند.`;

      case ActivityVerbEnum.Polled:
        return `باشگاه کتابخوانی ${actorName} یک نظرسنجی جدید ایجاد کرد.`;

      case ActivityVerbEnum.PollClosed:
        return `باشگاه کتابخوانی ${actorName} نظرسنجی خود را به پایان رساند.`;

      case ActivityVerbEnum.Meetinged:
        return activity?.inDirectObject !== null
          ? `باشگاه کتابخوانی ${actorName} رویداد ${data.Subject} را برگزار می‌کند.`
          : '';

      case ActivityVerbEnum.ClubJoinRequestAccepted:
        return `درخواست عضویت شما در باشگاه کتابخوانی ${data?.name} توسط ${actorName} پذیرفته شد.`;

      case ActivityVerbEnum.ClubInvited:
        return `${actorName} شما را به باشگاه ${data.name} دعوت کرد.`;


      default:
        return '';
    }
  }

  // ---------- Template context ----------
  private getTemplateText(activity: ActivitiesAggrigatorModel): string {

    const data = activity?.inDirectObject?.data;
    const courseName = activity?.object?.data?.book?.name;

    switch (activity?.verb) {
      case ActivityVerbEnum.ClubJoinRequestAccepted:
      case ActivityVerbEnum.ClubJoinRequested:
        return data?.name;

      case ActivityVerbEnum.Coursed:
      case ActivityVerbEnum.CourseEnded:
        return courseName;

      case ActivityVerbEnum.Meetinged:
        return activity?.inDirectObject?.data?.subject;

      case ActivityVerbEnum.Polled:
        return 'نظرسنجی ایجاد کرد.';

      case ActivityVerbEnum.PollClosed:
        return 'نظرسنجی خود را به اتمام رساند.';


      default:
        return '';
    }
  }
}

